<script>
export default {
	data() {
		return {

		}
	},
	created() {
  	this.emitter.on('gaEventTrack', this.gaEventTrack);
  },
  beforeUnmount() {
		this.emitter.off('gaEventTrack', this.gaEventTrack);
	},
	methods: {
		gaEventTrack(data) {
			if (window.GA_TRACKING_ID !== undefined) {
				gtag('event', data.action, {
					event_category: data.category,
					event_label: data.label,
				});
				//console.log("Tracking Event:",data.category, data.action, data.label);
			}
		}
	}
}
</script>
